import classNames from "classnames";
import { useDispatch, useSelector } from "react-redux";
import {
  selectSelectedActor,
  updateActor,
} from "../../app/slices/TrainingSlice";
import {
  ACTOR_AVATAR_PALETTE,
  getActorAvatarColorIndex,
  getActorAvatarColorByIndex,
} from "../../helpers/actorAvatar";

/** The avatar colour swatches: 28px dots, the selected one ringed in Creator blue. */
export default function ActorProfilePictureSelector() {
  const selectedActor = useSelector(selectSelectedActor);
  const dispatch = useDispatch();

  if (!selectedActor) return null;

  const selectedIndex = getActorAvatarColorIndex(selectedActor);

  const onColorClick = (index: number) => {
    dispatch(
      updateActor({
        ...selectedActor,
        profilePicture: index,
      })
    );
  };

  return (
    <div className="actorpreseteditor-swatches" data-testid="actor-color-swatches">
      {ACTOR_AVATAR_PALETTE.map((_, index) => {
        const isSelected = selectedIndex === index;
        return (
          <button
            type="button"
            key={index}
            aria-label={`color-${index}`}
            aria-pressed={isSelected}
            data-testid={`actor-color-${index}`}
            onClick={() => onColorClick(index)}
            className={classNames(
              "actorpreseteditor-swatch",
              getActorAvatarColorByIndex(index),
              { "actorpreseteditor-swatch--selected": isSelected }
            )}
          />
        );
      })}
    </div>
  );
}
